import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { ContactDetails } from "./Contact";

export const Footer = () => (
  <footer className="bg-[#0F231F] text-white border-t border-white/10" data-testid="site-footer">
    <div className="max-w-[1320px] mx-auto px-5 sm:px-8 lg:px-12 py-12 flex flex-col lg:flex-row items-center justify-between gap-8">
      <Link to="/" data-testid="footer-logo-link"><Logo variant="light" size={32} /></Link>
      <ContactDetails small />
      <p className="text-[12px] text-white/60 text-center" data-testid="footer-copyright">
        © {new Date().getFullYear()} Scale Solutions. All rights reserved.
      </p>
    </div>
  </footer>
);
